export default __webpack_public_path__ + "static/media/profile.516e68a6.png";